// quantity-bundle-variants.js
class QuantityBundle {
  constructor(container) {
    console.log("=== 🚀 QUANTITY BUNDLE INICIADO ===");
    
    this.container = container;
    this.radioButtons = container.querySelectorAll(".quantity-bundle__radio");
    this.buyButton = container.querySelector(".quantity-bundle__buy-button");
    this.comparePriceEl = container.querySelector(".quantity-bundle__compare-price");
    this.currentPriceEl = container.querySelector(".quantity-bundle__current-price");
    this.installmentsEl = container.querySelector(".installments");
    this.pixDiscountEl = container.querySelector('.pix-discount .value-pix-discount');

    // Preços base da variante (em centavos no Shopify)
    this.basePrice = parseFloat(container.dataset.basePrice) / 100;
    this.baseComparePrice = parseFloat(container.dataset.baseComparePrice) / 100;
    
    console.log("💰 Preços base:", {
      price: this.basePrice,
      comparePrice: this.baseComparePrice
    });

    this.init();
  }

  init() {
    this.bindEvents();
    this.updatePrices(); // Calcular preços iniciais
  }

  bindEvents() {
    // Ao mudar quantidade
    this.radioButtons.forEach((radio) => {
      radio.addEventListener("change", () => {
        console.log("🔄 Opção alterada");
        this.updatePrices();
        this.updateVisualSelection();
      });
    });

    // Clique na opção inteira
    this.container.querySelectorAll(".quantity-bundle__option").forEach((option) => {
      option.addEventListener("click", (e) => {
        if (e.target.type !== "radio") {
          const radio = option.querySelector(".quantity-bundle__radio");
          if (radio) {
            radio.checked = true;
            radio.dispatchEvent(new Event("change"));
          }
        }
      });
    });

    // Botão de compra
    this.buyButton.addEventListener("click", () => this.addToCart());

    // Mudança de variante
    const variantSelector = document.querySelector('[name="id"]');
    if (variantSelector) {
      variantSelector.addEventListener("change", async () => {
        await this.updateVariantPrices();
        this.updatePrices();
      });
    }
  }

  async updateVariantPrices() {
    const variantId = document.querySelector('[name="id"]')?.value;
    if (!variantId) return;

    try {
      const handle = window.location.pathname.match(/\/products\/([^\/]+)/)?.[1];
      if (!handle) return;

      const response = await fetch(`/products/${handle}.js`);
      const product = await response.json();
      const variant = product.variants.find(v => v.id == variantId);

      if (variant) {
        this.basePrice = variant.price / 100;
        this.baseComparePrice = (variant.compare_at_price || variant.price) / 100;
        console.log("💰 Preços atualizados:", { price: this.basePrice, comparePrice: this.baseComparePrice });
      }
    } catch (error) {
      console.error("❌ Erro ao atualizar variante:", error);
    }
  }

updatePrices() {
  const selectedRadio = this.container.querySelector(".quantity-bundle__radio:checked");
  if (!selectedRadio) return;

  const quantity = parseInt(selectedRadio.value);
  const discount = parseFloat(selectedRadio.dataset.discount) || 0;

  console.log(`\n📊 CALCULANDO PARA ${quantity} UNIDADES COM ${discount}% DE DESCONTO:`);

  // Calcular totais
  const totalCompare = this.baseComparePrice * quantity;
  const totalBeforeDiscount = this.basePrice * quantity;
  const totalAfterDiscount = totalBeforeDiscount * (1 - discount / 100);

  console.log({
    preçoUnitário: this.basePrice,
    compareUnitário: this.baseComparePrice,
    quantidade: quantity,
    desconto: discount + "%",
    totalCompare: totalCompare.toFixed(2),
    totalAntes: totalBeforeDiscount.toFixed(2),
    totalDepois: totalAfterDiscount.toFixed(2),
    economia: (totalBeforeDiscount - totalAfterDiscount).toFixed(2)
  });

  // ✅ ATUALIZAR PREÇO RISCADO (COMPARE PRICE)
  // Se o produto não tem compare_at_price, usar o preço cheio sem desconto
  const displayComparePrice = this.baseComparePrice > this.basePrice 
    ? totalCompare 
    : totalBeforeDiscount;

  this.comparePriceEl.textContent = this.formatPrice(displayComparePrice);
  this.currentPriceEl.textContent = this.formatPrice(totalAfterDiscount);

  console.log("💵 Preços exibidos:", {
    riscado: displayComparePrice.toFixed(2),
    atual: totalAfterDiscount.toFixed(2)
  });

  // Esconder compare price se quantidade = 1 E não houver desconto
  const compareWrapper = this.container.querySelector('.quantity-bundle__compare-price-wrapper');
  if (compareWrapper) {
    // Mostrar se: quantidade > 1 OU há desconto aplicado
    const shouldShow = quantity > 1 || discount > 0;
    compareWrapper.classList.toggle('hidden', !shouldShow);
  }

  // Atualizar parcelas
  this.updateInstallments(totalAfterDiscount);

  // Atualizar PIX
  if (this.pixDiscountEl) {
    const pixDiscount = parseFloat(this.pixDiscountEl.closest('.pix-discount').dataset.pixDiscountValue) || 0;
    const pixPrice = totalAfterDiscount * (1 - pixDiscount / 100);
    this.pixDiscountEl.textContent = this.formatPrice(pixPrice);
  }
}

  updateInstallments(totalPrice) {
    if (!this.installmentsEl) return;

    const maxParcels = parseInt(this.installmentsEl.dataset.parcelQuantity) || 12;
    const minParcelValue = parseFloat(this.installmentsEl.dataset.minParcelValue) || 5;

    let parcels = 1;
    let parcelValue = totalPrice;

    for (let i = maxParcels; i >= 1; i--) {
      const value = totalPrice / i;
      if (value >= minParcelValue) {
        parcels = i;
        parcelValue = value;
        break;
      }
    }

    const p = this.installmentsEl.querySelector("p");
    if (p) {
      p.innerHTML = `ou até <strong>${parcels}x</strong> de <strong>${this.formatPrice(parcelValue)}</strong> sem juros`;
    }
  }

  updateVisualSelection() {
    this.container.querySelectorAll(".quantity-bundle__option").forEach((opt) => {
      opt.classList.remove("quantity-bundle__option--selected");
    });

    const selected = this.container.querySelector(".quantity-bundle__radio:checked");
    if (selected) {
      selected.closest(".quantity-bundle__option").classList.add("quantity-bundle__option--selected");
    }
  }

  formatPrice(price) {
    return "R$" + price.toFixed(2).replace(".", ",");
  }

 async addToCart() {
  const selectedRadio = this.container.querySelector(".quantity-bundle__radio:checked");
  if (!selectedRadio) return;

  const quantity = parseInt(selectedRadio.value);
  const variantId = document.querySelector('[name="id"]')?.value || this.container.dataset.variantId;

  console.log("🛒 Adicionando ao carrinho:", { variantId, quantity });

  try {
    this.buyButton.disabled = true;
    this.buyButton.textContent = "Adicionando...";

    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: parseInt(variantId),
        quantity: quantity,
        sections: "cart-drawer,cart-icon-bubble",
        sections_url: window.location.pathname
      }),
    });

    if (!response.ok) {
      throw new Error("Erro ao adicionar ao carrinho");
    }

    const data = await response.json();
    console.log("✅ Produto adicionado:", data);

    // Atualizar o carrinho
    await this.updateCart(data);

    // Feedback visual
    this.buyButton.textContent = "✓ Adicionado!";
    this.buyButton.style.background = "#4CAF50";

    // Aguardar um pouco e abrir o carrinho
    setTimeout(() => {
      this.openCartDrawer();
      this.restoreButton();
    }, 800);

  } catch (error) {
    console.error("❌ Erro ao adicionar:", error);
    this.buyButton.textContent = "Erro - Tente novamente";
    this.buyButton.style.background = "#f44336";
    setTimeout(() => this.restoreButton(), 2000);
  }
}

async updateCart(data) {
  try {
    // Disparar evento para o tema saber que o carrinho foi atualizado
    document.dispatchEvent(new CustomEvent('cart:updated', {
      detail: { cart: data }
    }));

    // Atualizar o cart drawer se houver seções retornadas
    if (data.sections) {
      const cartDrawer = document.querySelector("cart-drawer");
      if (cartDrawer && typeof cartDrawer.renderContents === "function") {
        cartDrawer.renderContents(data);
      }
    } else {
      // Se não retornou seções, fazer um refresh manual do cart drawer
      const cartDrawer = document.querySelector("cart-drawer");
      if (cartDrawer) {
        // Força o cart drawer a recarregar seu conteúdo
        const cartResponse = await fetch('/?sections=cart-drawer,cart-icon-bubble');
        const sections = await cartResponse.json();
        
        if (typeof cartDrawer.renderContents === "function") {
          cartDrawer.renderContents({ sections });
        }
      }
    }

    // Atualizar o ícone do carrinho
    const cartIconBubble = document.querySelector("cart-icon-bubble");
    if (cartIconBubble) {
      const countResponse = await fetch('/cart.js');
      const cart = await countResponse.json();
      
      const countElement = cartIconBubble.querySelector('.cart-count-bubble span');
      if (countElement && cart.item_count) {
        countElement.textContent = cart.item_count;
        cartIconBubble.classList.remove('cart-count-bubble--hidden');
      }
    }

  } catch (error) {
    console.error("❌ Erro ao atualizar carrinho:", error);
  }
}

openCartDrawer() {
  console.log("🎯 Abrindo carrinho...");
  
  const cartDrawer = document.querySelector("cart-drawer");
  
  if (cartDrawer) {
    // Remover classe is-empty se existir
    cartDrawer.classList.remove("is-empty");
    
    // Tentar método open()
    if (typeof cartDrawer.open === "function") {
      cartDrawer.open();
      console.log("✅ Carrinho aberto via open()");
      return;
    }
    
    // Alternativa: adicionar classe active
    cartDrawer.classList.add("active");
    console.log("✅ Carrinho aberto via classe active");
    return;
  }
  
  // Fallback: clicar no ícone do carrinho
  const cartIcon = document.querySelector("#cart-icon-bubble");
  if (cartIcon) {
    cartIcon.click();
    console.log("✅ Carrinho aberto via clique no ícone");
  } else {
    console.warn("⚠️ Não foi possível abrir o carrinho");
  }
}

restoreButton() {
  this.buyButton.disabled = false;
  this.buyButton.textContent = "Comprar agora";
  this.buyButton.style.background = "";
}
}

// Inicializar
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".quantity-bundle").forEach((bundle) => {
    new QuantityBundle(bundle);
  });
});